import axios from "axios";

const instance = axios.create({
  baseURL: "/api", // <-- this is all you need
});


// Optional: Add token to every request automatically
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
